<ng-container *ngIf="show">
  <div class="iframe-wrapper">
    <iframe #iFrame
            id="dcp-iframe"
            title="{{ title }}"
            [src]="url | safeResourceUrl"
    ></iframe>
    <!-- DCP Configurator -->
  </div>
</ng-container>
